import React from "react";
import "./Image.scss";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions";

export default function Image(props) {
  let className = "intervention-image";
  if (props.className) className += ` ${props.className}`;
  return <img src={props.src} className={className} style={props.style} alt="" />;
}

export function ImageOption(props) {
  let status = "";
  if (props.waiting) status = "waiting";
  if (props.highlighted) status += "highlighted";
  if (props.selected) status = "selected";
  if (props.disabled) status = "disabled";

  return (
    <img
      src={props.src}
      className={`intervention-image-option ${status}`}
      {...doNotUseAccessibleStaticElementInteractions({onClick: onClick})}
      alt=""
    />
  );

  function onClick() {
    if (status) return;
    if (props.onClick) props.onClick();
  }
}
